/**
 * LoadingScreen.tsx — Full-page loading indicator
 * Used during session hydration and lazy route loading
 */

export default function LoadingScreen(): React.ReactElement {
  return (
    <div
      className="flex min-h-dvh items-center justify-center bg-surface"
      role="status"
      aria-label="Cargando…"
    >
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div
          className="h-10 w-10 rounded-full border-4 border-border border-t-brand-600 animate-spin"
          aria-hidden="true"
        />
        {/* Brand */}
        <p className="text-sm font-medium text-text-secondary">Kapi POS</p>
      </div>
    </div>
  );
}
